import Section from './Section';
import TemplateType from './TemplateType';

interface Template {
  id: string;
  name: string;
  reference_label: string;
  type: TemplateType;
  user_revision: number;
  exam_sections: Section[];
}

export type NewTemplate = Omit<Template, 'id'>;

const newTemplate = (): NewTemplate => ({
  name: '',
  reference_label: '',
  type: TemplateType.ASSESSMENT,
  exam_sections: [],
  user_revision: 1,
});

export { newTemplate };

export default Template;
